module.exports = __webpack_public_path__ + "img/notyet.5384789d.png";